<!--
 * @Author: Latte
 * @Date: 2021-08-30 16:07:34
 * @LAstEditors: Latte
 * @LastEditTime: 2021-09-02 09:53:53
 * @FilePath: \Siui.Cloud.Medical.Web\src\components\MyTable\MyToolbar\index.vue
-->
<template>
  <div class="topbar">
    <div class="left">
      <el-input
        size="small"
        prefix-icon="el-icon-search"
        class="search-input"
        v-model="searchValue"
      ></el-input>
      <el-button
        type="primary"
        size="small"
        icon="el-icon-search"
        @click.stop="search(searchValue)"
        >搜索</el-button
      >
      <el-button
        type="info"
        size="small"
        icon="el-icon-refresh"
        @click.stop="reset()"
        >重置</el-button
      >
    </div>
    <div class="right">
      <el-button
        type="primary"
        size="small"
        icon="el-icon-plus"
        @click.stop="add()"
        >{{ btnLabel }}</el-button
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "MyToolbar",
  props: {
    btnLabel: {
      type: String,
      default: () => '',
    }
  },
  data() {
    return {
      searchValue: "", // 搜索框内容
    };
  },
  methods: {
    search() {
      this.$emit('search',this.searchValue)
    },
    reset() {
      this.$emit('reset')
    },
    add() {
      this.$emit('add')
    },
  }
};
</script>

<style>
</style>